import { render, staticRenderFns } from "./CorporateCardComponent.vue?vue&type=template&id=4f301f64&"
import script from "./CorporateCardComponent.vue?vue&type=script&lang=js&"
export * from "./CorporateCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports